import { useMemo } from "react";
import { useWorkspacesList } from "@api/workspace.api";
import { useScope } from "@state/scopeContext.lib";

export const useWorkspaceClientName = (
    workspaceId: string | null | undefined,
): string | null => {
    const { organizationId } = useScope();
    const { data: workspaces = [] } = useWorkspacesList(
        organizationId ? { organizationId } : undefined,
    );

    return useMemo(() => {
        if (!workspaceId) {
            return null;
        }
        return workspaces.find((ws) => ws.id === workspaceId)?.name ?? null;
    }, [workspaces, workspaceId]);
};
